import { useState, useEffect } from 'react';
import { getTenantSettings, updateTenantSettings } from '../../api/tenant';
import AlertBanner from '../../components/common/AlertBanner';
import LoadingSpinner from '../../components/common/LoadingSpinner';

export default function GeneralSettingsPage() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [existingConfig, setExistingConfig] = useState({});
  const [builderPhasesCollapsed, setBuilderPhasesCollapsed] = useState(false);

  useEffect(() => {
    getTenantSettings()
      .then((tenantData) => {
        const cfg = tenantData?.config || {};
        setExistingConfig(cfg);
        setBuilderPhasesCollapsed(cfg.builder_phases_collapsed ?? false);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const fields = { builder_phases_collapsed: builderPhasesCollapsed };
      await updateTenantSettings({ config: { ...existingConfig, ...fields } });
      setExistingConfig((prev) => ({ ...prev, ...fields }));
      setSuccess('Einstellungen gespeichert.');
    } catch (e) {
      setError(e.message || 'Fehler beim Speichern.');
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <LoadingSpinner />;

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center pb-2 mb-4 border-bottom">
        <h1 className="h2">
          <i className="bi bi-sliders me-2" />
          Allgemein
        </h1>
      </div>

      {error && <AlertBanner message={error} type="danger" onDismiss={() => setError('')} />}
      {success && <AlertBanner message={success} type="success" onDismiss={() => setSuccess('')} />}

      <form onSubmit={handleSave}>
        <div className="card mb-4">
          <div className="card-header">
            <i className="bi bi-layout-text-window me-2" />
            Workout-Builder
          </div>
          <div className="card-body">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="builderPhasesCollapsed"
                checked={builderPhasesCollapsed}
                onChange={(e) => setBuilderPhasesCollapsed(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="builderPhasesCollapsed">
                Phasen beim Öffnen eines Workouts standardmäßig zugeklappt
              </label>
            </div>
            <div className="form-text">
              Wenn aktiviert, werden alle Phasen (Aufwärmen, Hauptteil, Abkühlen) beim Öffnen
              des Workout-Builders zugeklappt angezeigt. Der zuletzt eingestellte Zustand wird
              pro Workout gespeichert und beim nächsten Besuch wiederhergestellt.
            </div>
          </div>
        </div>

        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? (
            <><span className="spinner-border spinner-border-sm me-2" />Speichern…</>
          ) : (
            <><i className="bi bi-floppy me-1" />Speichern</>
          )}
        </button>
      </form>
    </div>
  );
}
